import React from 'react';
import PagedEntitiesList from '../../common/components/PagedEntitiesList';
import { ConfirmationButton } from '../../common/components/formControls';
import AddNoteForm from './SettingsForm';
import SearchNoteForm from './Filter';
import { withTranslation } from 'react-i18next';
import moment from 'moment';
import { Row, Col, Dropdown } from 'react-bootstrap';
import { faTrash } from '@fortawesome/free-solid-svg-icons';

const List = ({ isReadOnly, onAdd, onDelete, onSearch, t, ...rest }) => {
	const columns = [
		{
			accessor: 'text',
			cell: (text, note) => <div>
				<div style={{ marginBottom: '5px', whiteSpace: 'pre-line', fontSize: '14px' }}>{text}</div>
				<div className='text-muted'>{t('Note_Created', { date: moment(note.created).fromNow(), user: note.createdBy })}</div>
			</div>
		}
	];

	if (!isReadOnly) {
		columns.push({
			accessor: 'id',
			cell: id => <ConfirmationButton btnClasses='btn-sm' onConfirmation={() => onDelete(id)} confirmationTitle={t('Note_DeleteConfirmationTitle')}
				confirmationMessage={t('Note_DeleteConfirmationMessage')} displayType='inline' icon={faTrash}></ConfirmationButton>
		});
	}

	const listActions = <Row>
		<Col sm={8}>
			<SearchNoteForm onSubmit={onSearch} />
		</Col>
		<Col sm={4}>
			{!isReadOnly && <Dropdown className='pull-right'>
				<Dropdown.Toggle bsStyle='success'>{t('Common_New')}</Dropdown.Toggle>
				<Dropdown.Menu style={{ padding: 10, minWidth: 300 }}><AddNoteForm onSubmit={onAdd} /></Dropdown.Menu>
			</Dropdown>}
		</Col>
	</Row>;

	return (
		<div>
			<PagedEntitiesList columns={columns} listActions={listActions} {...rest} />
		</div>
	);
};

export default withTranslation()(List);